import { useContext } from 'preact/hooks';
import { ConsentContext } from './ConsentContext';

export function useWidgetConsent() {
  return useContext(ConsentContext);
}
